import { render, staticRenderFns } from "./CheckProtocol.vue?vue&type=template&id=6e23d81c&scoped=true"
import script from "./CheckProtocol.vue?vue&type=script&lang=js"
export * from "./CheckProtocol.vue?vue&type=script&lang=js"
import style0 from "./CheckProtocol.vue?vue&type=style&index=0&id=6e23d81c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e23d81c",
  null
  
)

export default component.exports